import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import useToggle from 'hooks/useToggle';
import { InfoWidget } from '@ds/react-components';
import moment from 'moment';
import {
  RowRightText,
  RowLeftText,
  RowContainer,
} from '../common/InfoRowComponents';

import * as Styled from './GuarantorDetails.styled';

const GuarantorDetails = (props) => {
  const { localisation, guarantorInfo } = props;

  const [expandContact, toggleExpandContact] = useToggle(false);

  const { dateFormat } = localisation.locales;

  const formattedDateOfBirth = useMemo(() => {
    if (!guarantorInfo) return null;
    const { dob } = guarantorInfo;
    return dob ? moment(dob).format(dateFormat) : null;
  }, [guarantorInfo, dateFormat]);

  const formattedDateSigned = useMemo(() => {
    if (!guarantorInfo) return null;
    const { dated } = guarantorInfo;
    return dated ? moment(dated).format(dateFormat) : null;
  }, [guarantorInfo, dateFormat]);

  if (!guarantorInfo) {
    return <> </>;
  }

  const { name, relation, address, phHm, phWk } = guarantorInfo;

  return (
    <InfoWidget title={'Guarantor Information'}>
      <Styled.Container>
        <RowContainer>
          <RowLeftText>{'Guarantor name'} </RowLeftText>
          <RowRightText>{name || '-'} </RowRightText>
        </RowContainer>
        <RowContainer>
          <RowLeftText>{'Relationship'} </RowLeftText>
          <RowRightText>{relation || '-'} </RowRightText>
        </RowContainer>
        <RowContainer>
          <RowLeftText>{'Date of birth'} </RowLeftText>
          <RowRightText>{formattedDateOfBirth || '-'} </RowRightText>
        </RowContainer>

        <RowContainer>
          <RowLeftText>{'Contact'} </RowLeftText>
          {phHm && phWk ? (
            <Styled.RowRightTextButton onClick={toggleExpandContact}>
              <span>{phHm || phWk}</span>
              {expandContact ? (
                <Styled.ExpandLessIcon />
              ) : (
                <Styled.ExpandMoreIcon />
              )}
            </Styled.RowRightTextButton>
          ) : (
            <RowRightText>{phHm || phWk || '-'}</RowRightText>
          )}
        </RowContainer>

        <Styled.Collapsible in={expandContact} timeout="auto" unmountOnExit>
          {phHm && (
            <RowContainer last={!phWk}>
              <RowLeftText>{'Home'}</RowLeftText>
              <RowRightText>{phHm}</RowRightText>
            </RowContainer>
          )}
          {phWk && (
            <RowContainer last={true}>
              <RowLeftText>{'Work'} </RowLeftText>
              <RowRightText>{phWk}</RowRightText>
            </RowContainer>
          )}
        </Styled.Collapsible>

        <RowContainer>
          <RowLeftText>{'Address'} </RowLeftText>
          <RowRightText>{address || '-'} </RowRightText>
        </RowContainer>
        <RowContainer>
          <RowLeftText>{'Date signed'} </RowLeftText>
          <RowRightText>{formattedDateSigned || '-'} </RowRightText>
        </RowContainer>
      </Styled.Container>
    </InfoWidget>
  );
};

GuarantorDetails.propTypes = {
  localisation: PropTypes.object.isRequired,
  guarantorInfo: PropTypes.shape({
    name: PropTypes.string,
    address: PropTypes.string,
    dated: PropTypes.string,
    phHm: PropTypes.string,
    phWk: PropTypes.string,
    relation: PropTypes.string,
    dob: PropTypes.string,
  }),
};

GuarantorDetails.defaultProps = {
  guarantorInfo: null,
};

export default GuarantorDetails;
